import { AppPageHeader } from '@/components/_common';
import { ListSuppliersQuery } from '@/core/domain/people/Suppliers/Suppliers.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { Button } from 'antd';

import { useIntl } from 'react-intl';
import SupplierExtraFilters from '../SupplierExtraFilters';

const SuppliersFilters: React.FC<ExtraFiltersProps<ListSuppliersQuery>> = ({
  queryParams,
  setQueryParams,
}) => {
  const intl = useIntl();

  return (
    <AppPageHeader
      onSearch={(value) =>
        setQueryParams((prev) => ({ ...prev, search: value }))
      }
      searchValue={queryParams?.search}
      extraFilters={
        <SupplierExtraFilters
          queryParams={queryParams}
          setQueryParams={setQueryParams}
        />
      }
      headerActions={({
        isShowingFilters,
      }: {
        // eslint-disable-next-line react/no-unused-prop-types
        isShowingFilters: boolean;
      }) =>
        isShowingFilters && (
          <Button type="primary" onClick={() => setQueryParams({})}>
            {intl.formatMessage({ id: 'commons.clear.filters' })}
          </Button>
        )
      }
    />
  );
};

export default SuppliersFilters;
